export default __webpack_public_path__ + "pgnv-assets/ecf03949721251a27de5145d331ff823.png";